var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "left-box",
          attrs: {
            "body-style":
              "height:calc(100vh - 70px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                display: "flex",
                "font-size": "18px",
                "font-weight": "bold",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticStyle: { color: "#000" } }, [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push(
                          "/ProjectInfo/ProjectAll?id=" + _vm.$route.query.id
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.backName || "工作台"))]
                ),
                _c("i", { staticClass: "el-icon-arrow-right" }),
              ]),
              _c(
                "div",
                { staticClass: "ellipsis", staticStyle: { color: "#606266" } },
                [_vm._v("供应商资质审核")]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dataStatisticsLoading,
                  expression: "dataStatisticsLoading",
                },
              ],
              staticClass: "headData",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                width: "100%",
                height: "110px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { height: "100%", width: "100%" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { staticStyle: { height: "100%" }, attrs: { span: 4 } },
                    [
                      _c(
                        "el-card",
                        { staticStyle: { width: "100%", height: "110px" } },
                        [
                          _c(
                            "el-statistic",
                            {
                              attrs: {
                                value: Math.round(
                                  Number(_vm.dataStatistics.deviceCount || 0)
                                ),
                                "value-style": {
                                  fontSize: "24px",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "font-weight": "bold",
                                        color: "#e6a23c",
                                      },
                                    },
                                    [_vm._v(" 所有资料数量 ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { height: "100%" }, attrs: { span: 4 } },
                    [
                      _c(
                        "el-card",
                        { staticStyle: { width: "100%", height: "110px" } },
                        [
                          _c(
                            "el-statistic",
                            {
                              attrs: {
                                value: Math.round(
                                  Number(
                                    _vm.dataStatistics.TwoSupplierCount || 0
                                  )
                                ),
                                "value-style": {
                                  fontSize: "24px",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "font-weight": "bold",
                                        color: "#e6a23c",
                                      },
                                    },
                                    [_vm._v(" 已提交资料数量 ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { height: "100%" }, attrs: { span: 4 } },
                    [
                      _c(
                        "el-card",
                        { staticStyle: { width: "100%", height: "110px" } },
                        [
                          _c(
                            "el-statistic",
                            {
                              attrs: {
                                value: Math.round(
                                  Number(_vm.dataStatistics.DocumentCount || 0)
                                ),
                                "value-style": {
                                  fontSize: "24px",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "font-weight": "bold",
                                        color: "#e6a23c",
                                      },
                                    },
                                    [_vm._v(" 已通过资料数量 ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { height: "100%" }, attrs: { span: 4 } },
                    [
                      _c(
                        "el-card",
                        { staticStyle: { width: "100%", height: "110px" } },
                        [
                          _c(
                            "el-statistic",
                            {
                              attrs: {
                                value: Math.round(
                                  Number(_vm.dataStatistics.AccessoryCount || 0)
                                ),
                                "value-style": {
                                  fontSize: "24px",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "font-weight": "bold",
                                        color: "#e6a23c",
                                      },
                                    },
                                    [_vm._v(" 驳回资料数量 ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { height: "100%" }, attrs: { span: 4 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            position: "relative",
                          },
                          attrs: {
                            "body-style": {
                              padding: 0,
                            },
                          },
                        },
                        [
                          _c("div", {
                            staticStyle: {
                              width: "100%",
                              height: "calc(100%)",
                              "margin-top": "60px",
                            },
                            attrs: { id: "DeviceProgress" },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                height: "30px",
                                width: "100%",
                                position: "absolute",
                                top: "0",
                                left: "0",
                                "text-align": "center",
                                "font-weight": "bold",
                                "font-size": "18px",
                                "line-height": "30px",
                              },
                            },
                            [
                              _vm._v(" 提交率"),
                              _vm.SupplyType == "1"
                                ? _c("span", { staticClass: "hint-text" }, [
                                    _vm._v("(乙供)"),
                                  ])
                                : _vm._e(),
                              _vm.SupplyType == "3"
                                ? _c("span", { staticClass: "hint-text" }, [
                                    _vm._v("(甲供)"),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { height: "100%" }, attrs: { span: 4 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            position: "relative",
                          },
                          attrs: {
                            "body-style": {
                              padding: 0,
                            },
                          },
                        },
                        [
                          _c("div", {
                            staticStyle: {
                              width: "100%",
                              height: "calc(100%)",
                              "margin-top": "60px",
                            },
                            attrs: { id: "DocumentProgress" },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                height: "30px",
                                width: "100%",
                                position: "absolute",
                                top: "0",
                                left: "0",
                                "text-align": "center",
                                "font-weight": "bold",
                                "font-size": "18px",
                                "line-height": "30px",
                              },
                            },
                            [
                              _vm._v(" 通过率"),
                              _vm.SupplyType == "1"
                                ? _c("span", { staticClass: "hint-text" }, [
                                    _vm._v("(乙供)"),
                                  ])
                                : _vm._e(),
                              _vm.SupplyType == "3"
                                ? _c("span", { staticClass: "hint-text" }, [
                                    _vm._v("(甲供)"),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { width: "100%", "margin-top": "20px" } },
            [
              _c(
                "el-table",
                {
                  attrs: { height: "calc(100vh - 290px)", data: _vm.dataList },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "序号",
                      width: "55",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "SupplierName",
                      label: "供应商名称",
                      align: "center",
                      width: "350px",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cVenPerson",
                      label: "联系人",
                      align: "center",
                      width: "150px",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cVenPhone",
                      label: "联系电话",
                      align: "center",
                      width: "150px",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "InforName",
                      label: "已上传资料类型",
                      "show-overflow-tooltip": "",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Status",
                      label: "状态",
                      width: "120px",
                      align: "center",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.Status == 1
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.Reviewer?.length == 1
                                          ? "部分审核"
                                          : "待审核"
                                      ) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            scope.row.Status == 2 || scope.row.Status == 3
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v("已审核 ")]
                                )
                              : _vm._e(),
                            scope.row.Status == 4
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [_vm._v("驳回 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "审核人",
                      prop: "Reviewer",
                      width: "130",
                      align: "center",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.Reviewer || [],
                            function (item) {
                              return _c("el-tag", { key: item }, [
                                _vm._v(_vm._s(item)),
                              ])
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "AccessoryCode",
                      label: "操作",
                      align: "center",
                      width: "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#e6a23c" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.auditView(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v("记录")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                display: "flex",
                "align-items": "center",
                "justify-content": "right",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.PageIndex,
                  "page-sizes": _vm.pagination.PageSizes,
                  "page-size": _vm.pagination.PageRows,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            "close-on-press-escape": false,
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  display: "flex",
                  "align-items": "center",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.drawer = false
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
                _c("div", [_vm._v(_vm._s(_vm.title))]),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.drawerLoading,
                  expression: "drawerLoading",
                },
              ],
              staticStyle: {
                width: "100%",
                height: "calc(100vh - 120px)",
                "overflow-y": "auto",
                "overflow-x": "hidden",
                "box-sizing": "border-box",
                padding: "0 20px",
                display: "flex",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { width: "calc(100% - 240px)" } },
                [
                  _vm._l(_vm.ProjectTableData, function (eell, indexeell) {
                    return _c(
                      "div",
                      { key: eell.Id },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: [eell], "row-key": "Id" },
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "TypeName", width: "200" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [_vm._v(" " + _vm._s("") + " ")]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          indexeell + 1 + "." + eell.TypeName
                                        )
                                      ),
                                    ]),
                                    _vm.ProjectStepList.find(
                                      (vv) => vv.DicValue == eell.Type
                                    )?.Remark || false
                                      ? _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom-start",
                                              "open-delay": 100,
                                              width: "200",
                                              trigger: "hover",
                                              content:
                                                _vm.ProjectStepList.find(
                                                  (vv) =>
                                                    vv.DicValue == eell.Type
                                                )?.Remark || "",
                                              "popper-class": "table-popper",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("el-table-column", {
                              attrs: {
                                prop: "Type",
                                label: "上传文件名称",
                                resizable: false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._l(
                                          scope.row.DocumentList,
                                          function (item) {
                                            return _c(
                                              "div",
                                              { key: item.uid },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlePreview(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.resname) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        scope.row.DocumentList.length == 0
                                          ? _c("span", [_vm._v("暂无数据")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "Size",
                                label: "文件大小",
                                align: "left",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._l(
                                          scope.row.DocumentList,
                                          function (item) {
                                            return _c(
                                              "div",
                                              { key: item.uid },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      color: "#000",
                                                      cursor: "default",
                                                    },
                                                    attrs: { type: "text" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.setSize(item.size)
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        scope.row.DocumentList.length == 0
                                          ? _c("span", [_vm._v("暂无数据")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "上传状态",
                                width: "100",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.DocumentList?.length > 0 &&
                                        scope.row.DocumentList?.every(
                                          (item) => item.status === "success"
                                        )
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-circle-check",
                                              staticStyle: {
                                                "font-size": "20px",
                                                color: "#67c23a",
                                              },
                                            })
                                          : _c("i", {
                                              staticClass:
                                                "el-icon-circle-close",
                                              staticStyle: {
                                                "font-size": "20px",
                                                color: "#f56c6c",
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm.approvalComments[eell.Type]
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  width: "100%",
                                  "font-size": "14px",
                                  "margin-top": "20px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "130px",
                                      "font-weight": "bold",
                                      "align-items": "center",
                                      "margin-right": "10px",
                                      "padding-left": "20px",
                                    },
                                  },
                                  [_vm._v("审核意见")]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "calc(100% - 150px)" },
                                  attrs: {
                                    placeholder: "未输入内容",
                                    type: "textarea",
                                    rows: 2,
                                    disabled: !(
                                      _vm.Status == 1 &&
                                      !_vm.signInfo.PropertyReviewName
                                    ),
                                    resize: "none",
                                    size: "mini",
                                  },
                                  model: {
                                    value:
                                      _vm.approvalComments[eell.Type].content,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.approvalComments[eell.Type],
                                        "content",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "approvalComments[eell.Type].content",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "form",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.signInfo,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-form-item", { attrs: { label: "" } }, [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "font-size": "16px",
                                        },
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v(" 业主： ")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-form-item", { attrs: { label: "" } }, [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "font-size": "16px",
                                        },
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v(" 顾问公司： ")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "姓名：" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.signInfo?.PropertyReviewName)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "姓名：" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.signInfo?.ExamineName) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "签名：" } },
                                    [
                                      _vm.signInfo?.PropertyReviewSign
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                "text-align": "center",
                                                "box-sizing": "border-box",
                                                overflow: "hidden",
                                                width: "200px",
                                                height: "100px",
                                              },
                                            },
                                            [
                                              _c("el-image", {
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100%",
                                                  background: "#fff",
                                                  "box-sizing": "border-box",
                                                },
                                                attrs: {
                                                  src: _vm.signInfo
                                                    ?.PropertyReviewSign,
                                                  alt: "",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "签名：" } },
                                    [
                                      _vm.signInfo?.Sign
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                "text-align": "center",
                                                "box-sizing": "border-box",
                                                overflow: "hidden",
                                                width: "200px",
                                                height: "100px",
                                              },
                                            },
                                            [
                                              _c("el-image", {
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100%",
                                                  background: "#fff",
                                                  "box-sizing": "border-box",
                                                },
                                                attrs: {
                                                  src: _vm.signInfo?.Sign,
                                                  alt: "",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "日期：" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.signInfo.PropertyReviewDate
                                              ? _vm
                                                  .moment(
                                                    _vm.signInfo
                                                      .PropertyReviewDate
                                                  )
                                                  .format("YYYY-MM-DD")
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "日期：" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.signInfo.ExamineTime
                                              ? _vm
                                                  .moment(
                                                    _vm.signInfo.ExamineTime
                                                  )
                                                  .format("YYYY-MM-DD")
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { staticStyle: { "margin-top": "30px" } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "提交人：" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.rowItem.SupplierName || ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "提交日期：" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.rowItem.InforTime
                                              ? _vm
                                                  .moment(_vm.rowItem.InforTime)
                                                  .format("YYYY-MM-DD")
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "steps-box",
                  staticStyle: { width: "220px", "margin-left": "20px" },
                },
                _vm._l(_vm.ProjectTableData, function (ele, index) {
                  return _c(
                    "div",
                    {
                      key: ele.Type,
                      style: `height: calc(100% / ${_vm.ProjectTableData.length});min-height: 150px;`,
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "100%", display: "flex" } },
                        [
                          _c("div", { staticClass: "steps-left" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  "steps",
                                  ele.DocumentList?.length > 0
                                    ? "steps-success"
                                    : "",
                                ],
                              },
                              [
                                ele.DocumentList?.length > 0
                                  ? _c("i", { staticClass: "el-icon-check" })
                                  : _c("span", [_vm._v(_vm._s(index + 1))]),
                              ]
                            ),
                            index != _vm.ProjectTableData.length - 1
                              ? _c("div", {
                                  class: [
                                    "steps-left-line",
                                    ele.DocumentList?.length > 0
                                      ? "steps-success-line"
                                      : "",
                                  ],
                                })
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "steps-right" }, [
                            _c("div", { staticClass: "steps-right-title" }, [
                              _c(
                                "span",
                                {
                                  class: [
                                    ele.DocumentList?.length > 0
                                      ? "steps-success"
                                      : "",
                                  ],
                                  staticStyle: { cursor: "pointer" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(index + 1) +
                                      "." +
                                      _vm._s(ele.TypeName)
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm.Status == 1 && !_vm.signInfo.PropertyReviewName
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.drawerLoading,
                      expression: "drawerLoading",
                    },
                  ],
                  staticStyle: {
                    "font-size": "12px",
                    color: "#999",
                    width: "100%",
                    "text-align": "right",
                    height: "40px",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "right",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.Audit(3, "审核")
                        },
                      },
                    },
                    [_vm._v("通过")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.Audit(4, "驳回")
                        },
                      },
                    },
                    [_vm._v("驳回")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请输入驳回原因",
            visible: _vm.rejectVisible,
            width: "400px",
            top: "20vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rejectVisible = $event
            },
            close: function ($event) {
              _vm.rejectVisible = false
            },
          },
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: 9, placeholder: "请输入内容" },
            model: {
              value: _vm.rejectValue,
              callback: function ($$v) {
                _vm.rejectValue = $$v
              },
              expression: "rejectValue",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rejectVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.Audit(4, "审核", true)
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("InfoStatistic", { ref: "InfoStatistic" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批注",
            visible: _vm.approvalDialogVisible,
            width: "500px",
            top: "15vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "approval-dialog-content" },
            [
              _c("div", { staticClass: "step-info" }, [
                _c("span", { staticClass: "step-name" }, [
                  _vm._v(_vm._s(_vm.currentStepName)),
                ]),
              ]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 8,
                  placeholder: "请输入批注",
                  maxlength: "500",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.approvalComment,
                  callback: function ($$v) {
                    _vm.approvalComment = $$v
                  },
                  expression: "approvalComment",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approvalDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveApprovalComment },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("SignDialog", { ref: "SignDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }